import { formatActionText } from 'pages/WellGuardian/WIR/utils';
import {
  INTERVENTION_CLOSE_OUT_ACTION_LABEL,
  WIRCreateJourneyStepsKeys,
  WIRInterventionCloseOutSectionKey,
  WIRInterventionCloseOutSections,
} from 'pages/WellGuardian/WIR/wir.constants';
import { CountryData, WIR, WIRActionStatus } from 'types/wellGuardian';

const getCGInterventionCloseOutSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRInterventionCloseOutSections)
        .map(item => ({
          label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.CG_INTERVENTION_CLOSE_OUT,
        }))
        .filter(stepItem =>
          stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.interventionRetrospective ||
          stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
          stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
          stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
          stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
          stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
          stepItem.label === WIRInterventionCloseOutSections.rex ||
          stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.closeOutChecklists ||
          stepItem.label === WIRInterventionCloseOutSections.interventionPerformanceCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.actualGhgEmission ||
          stepItem.label === WIRInterventionCloseOutSections.filesAddedToSharePoint
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                  /* istanbul ignore next */
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getAGInterventionCloseOutSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRInterventionCloseOutSections)
        .map(item => ({
          label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.AG_INTERVENTION_CLOSE_OUT,
        }))
        .filter(stepItem =>
          stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.interventionRetrospective ||
          stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
          stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
          stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
          stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
          stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
          stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.closeOutChecklists ||
          stepItem.label === WIRInterventionCloseOutSections.interventionPerformanceCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.actualGhgEmission ||
          stepItem.label === WIRInterventionCloseOutSections.filesAddedToSharePoint
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                  /* istanbul ignore next */
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getNGInterventionCloseOutSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRInterventionCloseOutSections)
        .map(item => ({
          label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.NG_INTERVENTION_CLOSE_OUT,
        }))
        .filter(stepItem =>
          stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
          stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
          stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
          stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
          stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
          stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.rex ||
          stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.filesAddedToSharePoint
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                  /* istanbul ignore next */
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getIRInterventionCloseOutSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRInterventionCloseOutSections)
        .map(item => ({
          label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.IRAQ_INTERVENTION_CLOSE_OUT,
        }))
        .filter(stepItem =>
          stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
          stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
          stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
          stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
          stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
          stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.rex ||
          stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.filesAddedToSharePoint
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                  /* istanbul ignore next */
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getARInterventionCloseOutSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRInterventionCloseOutSections)
        .map(item => ({
          label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.ARGENTINA_INTERVENTION_CLOSE_OUT,
        }))
        .filter(stepItem =>
          stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
          stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
          stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
          stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
          stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
          stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.rex ||
          stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.filesAddedToSharePoint
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                  /* istanbul ignore next */
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

const getBRInterventionCloseOutSections = (wir: WIR | null) => {
  return (
    (wir &&
      Object.keys(WIRInterventionCloseOutSections)
        .map(item => ({
          label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
          value: item,
          phase: WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT,
        }))
        .filter(stepItem =>
          stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
          stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
          stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
          stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
          stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
          stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
          stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut ||
          stepItem.label === WIRInterventionCloseOutSections.filesAddedToSharePoint
            ? wir?.actions?.some(
                item =>
                  item.actionName ===
                    formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                  /* istanbul ignore next */
                  item.state !== WIRActionStatus.DELETED,
              )
            : true,
        )) ??
    []
  );
};

export const getInterventionCloseOutSections = (wir: WIR | null, country: string) => {
  if (country === CountryData.congo) {
    return getCGInterventionCloseOutSections(wir);
  } else if (country === CountryData.nigeria) {
    return getNGInterventionCloseOutSections(wir);
  } else if (country === CountryData.iraq) {
    return getIRInterventionCloseOutSections(wir);
  } else if (country === CountryData.angola) {
    return getAGInterventionCloseOutSections(wir);
  } else if (country === CountryData.argentina) {
    return getARInterventionCloseOutSections(wir);
  } else if (country === CountryData.brazil) {
    return getBRInterventionCloseOutSections(wir);
  } else {
    return (
      (wir &&
        Object.keys(WIRInterventionCloseOutSections)
          .map(item => ({
            label: WIRInterventionCloseOutSections[item as WIRInterventionCloseOutSectionKey],
            value: item,
            phase: WIRCreateJourneyStepsKeys.INTERVENTION_CLOSE_OUT,
          }))
          .filter(stepItem =>
            stepItem.label === WIRInterventionCloseOutSections.wonsCloseOut ||
            stepItem.label === WIRInterventionCloseOutSections.lessonsCaptured ||
            stepItem.label === WIRInterventionCloseOutSections.capPortalCloseOut ||
            stepItem.label === WIRInterventionCloseOutSections.interventionSingleSlideSummary ||
            stepItem.label === WIRInterventionCloseOutSections.signOffWcrs ||
            stepItem.label === WIRInterventionCloseOutSections.completionSchematicUpdate ||
            stepItem.label === WIRInterventionCloseOutSections.wellSchematicUpdate ||
            stepItem.label === WIRInterventionCloseOutSections.emtraxUpdate ||
            stepItem.label === WIRInterventionCloseOutSections.interventionWellDataStored ||
            stepItem.label === WIRInterventionCloseOutSections.vendorCloseOut ||
            stepItem.label === WIRInterventionCloseOutSections.assetCloseOutPresentation ||
            stepItem.label === WIRInterventionCloseOutSections.costConsolidationCloseOut
              ? wir?.actions?.some(
                  item =>
                    item.actionName ===
                      formatActionText(stepItem.label, INTERVENTION_CLOSE_OUT_ACTION_LABEL) &&
                    /* istanbul ignore next */
                    item.state !== WIRActionStatus.DELETED,
                )
              : true,
          )) ??
      []
    );
  }
};
